import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import MenuItem from '#client/components/MenuItem';

const FilterOptions = ({
  selectedKey,
  options,
  disableAllOptions = false,
  handleClick,
  callback
}) => (
  <Stack
    spacing="8px"
    sx={{ maxHeight: '40vh' }}
  >
    {options.map(({ key, name }) => (
      <MenuItem
        disabled={disableAllOptions}
        key={key}
        onClick={() => {
          handleClick(key);
          callback?.();
        }}
        selected={key === selectedKey}
      >
        <Text variant={key === selectedKey ? 'body_largeBold' : 'bodyLargeRegular'}>{name}</Text>
      </MenuItem>
    ))}
  </Stack>
);

FilterOptions.propTypes = {
  selectedKey: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  disableAllOptions: PropTypes.bool,
  handleClick: PropTypes.func.isRequired,
  callback: PropTypes.func
};

export default FilterOptions;
